<template>
  <div>
    <NavTop class="navbar">
      <template v-slot:headerImgRight>
        <div class="img_top_text">党委办公室</div>
      </template>
      <template v-slot:mainnavlist>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            部门概括<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item class="dropdown_menu1">
              <div @click="routerpush('/')">学院介绍</div>
            </el-dropdown-item>
            <el-dropdown-item class="dropdown_menu1">
              <div @click="routerpush('/')">机构设置</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="navigateTo('/')">系部介绍</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            教学工作<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item class="dropdown_menu1">
              <div @click="routerpush('/')">教学活动</div>
            </el-dropdown-item>
            <el-dropdown-item class="dropdown_menu1">
              <div @click="routerpush('/')">相关制度</div>
            </el-dropdown-item>
            <el-dropdown-item class="dropdown_menu1">
              <div @click="routerpush('/')">教学用表</div>
            </el-dropdown-item>
            <el-dropdown-item class="dropdown_menu1">
              <div @click="routerpush('/')">教研教改</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            党团工作<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item class="dropdown_menu1">
              <div @click="routerpush('/')">支部建设</div>
            </el-dropdown-item>
            <el-dropdown-item class="dropdown_menu1">
              <div @click="routerpush('/')">团学活动</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="navigateTo('/')">文件下载</div>
        <div class="nav" @click="navigateTo('/')">成绩查询</div>
      </template>
    </NavTop>
    <!-- 部门新闻 -->
    <div class="deptNews content">
      <div class="deptNews_box">
        <div class="deptNews_box_left">
          <span>学院新闻</span>
          <a href="#">查看更多</a>
        </div>
        <div class="deptNews_box_right">
          <div class="deptNews_box_right_swiper">
            <swiper class="swiper2" :options="swiperOptions2">
              <swiper-slide class="swiper_img2" v-for="(slide, index) in slides" :key="index">
                <div class="swiper_img2_lefttop">
                  <span>17</span>
                  <span>2023-11</span>
                </div>
                <img :src="slide" alt="Slide Image">
                <div class="swiper_img2_title">
                  <span>我校扎实开展4·15全民国家安全日宣传教育活动</span>
                </div>
              </swiper-slide>
              <div class="swiper-pagination2" slot="pagination"></div>
            </swiper>
          </div>
          <div class="deptNews_box_right_list">
            <ul class="deptNews_box_right_list_ul">
              <li class="deptNews_box_right_list_ul_li" v-for="(item,index) in dept_list" :key="index">
                <a class="list_ul_li_a1" href="#">{{ item.title }}</a>
                <span class="list_ul_li_span">{{ item.time }}</span>
                <a class="list_ul_li_a2" href="#">
                  <img src="../../../assets/images/right1.png" alt>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 通知公告 -->
    <div class="notice">
      <div class="notice_ content">
        <div class="notice_con" v-for="(item,index) in noticeData" :key="index">
          <div class="notice_con_title">
            <span>{{ item.title }}</span>
            <a href="#">查看更多</a>
          </div>
          <div class="notice_con_list">
            <ul class="notice_con_list_ul">
              <li class="notice_con_list_ul_li" v-for="(item1,index1) in item.content" :key="index1">
                <a class="notice_con_list_ul_li_a" href="#">{{ item1.txt }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 实习实诊 -->
    <div class="shiX content">
      <div class="shiX_left">
        <div class="shiX_left_title">
          <span>教师风采</span>
          <a href="#">查看更多</a>
        </div>
        <div class="shiX_left_list">
          <ul class="shiX_left_list_ul">
            <li class="shiX_left_list_ul_li" v-for="(item,index) in zhibuData" :key="index">
              <a href="#">{{ item.txt }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="shiX_left">
        <div class="shiX_left_title">
          <span>团学活动</span>
          <a href="#">查看更多</a>
        </div>
        <div class="shiX_left_list">
          <ul class="shiX_left_list_ul">
            <li class="shiX_left_list_ul_li" v-for="(item,index) in zhibuData" :key="index">
              <a href="#">{{ item.txt }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="shiX_left">
        <div class="shiX_left_title">
          <span>学生园地</span>
          <a href="#">查看更多</a>
        </div>
        <div class="shiX_left_list">
          <ul class="shiX_left_list_ul">
            <li class="shiX_left_list_ul_li" v-for="(item,index) in zhibuData" :key="index">
              <a href="#">{{ item.txt }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import home from '../../api/home'
export default {
  data () {
    return {
      slides: [],
      swiperOptions2: {
        pagination: {el: '.swiper-pagination2', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 2000
      },
      // 轮播图
      bannerImg: [
        {
          img: require('../../../assets/images/new1.jpg'),
          txt: '我校张松老师受邀为廊坊开发区“送法进企业'
        },
        {
          img: require('../../../assets/images/new1.jpg'),
          txt: '我校张松老师受邀为廊坊开发区“送法进企业'
        }
      ],
      // 部门新闻列表
      dept_list: [
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        }
      ],
      // 通知公告数据
      noticeData: [
        {
          title: '通知公告',
          content: [
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            }
          ]
        }, {
          title: '教学活动',
          content: [
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            }
          ]
        }, {
          title: '学风建设',
          content: [
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            }
          ]
        }
      ],
      // 支部建设数据
      zhibuData: [
        {
          txt: '我院成功召开2023年下半年接收预备党员转正暨接收预备党员大会'
        },
        {
          txt: '我院成功召开2023年下半年接收预备党员转正暨接收预备党员大会'
        }
      ],
      // 团学活动数据
      tuanxueData: [
        {
          txt: '我院成功召开2023年下半年接收预备党员转正暨接收预备党员大会',
          time: '2023-11-14'
        },
        {
          txt: '我院成功召开2023年下半年接收预备党员转正暨接收预备党员大会',
          time: '2023-11-14'
        }
      ],
      currentIndexBanner: 0 // banner轮播图
    }
  },
  methods: {
    navigateTo (path) {
      this.$router.push(path)
    },
    handleCarouselChange (index) {
      this.currentIndexBanner = index
    }
    // async ppp () {
    //   try {
    //     const res = await home.getBanner()
    //     console.log(res)
    //   } catch (e) {
    //     console.log(e)
    //   }
    // }
  }
}
</script>
<style lang="less" scoped>
ul, li {
  list-style: none;
  color: #FFFFFF;
}

a {
  text-decoration: none !important;
}

.lunb {
  overflow: hidden;

  .lunb_con {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    transform: translateY(-45px);
    font-size: 15px;
    color: #FFFFFF;

    span {
      transform: translateX(-50px);
    }
  }
}

.banner_carousel {
  position: relative;
}

// 部门新闻
.deptNews {
  width: 100%;
  height: 450px;

  .deptNews_box {
    width: 100%;
    height: 450px;

    .deptNews_box_left {
      margin-bottom: 30px;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      align-items: center;


      span {
        font-size: 24px;
        color: #444;
        line-height: 50px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 2px;
          background: #9e070e;
        }
      }

      a {
        text-decoration: none;
        color: #666;
        position: relative;
        line-height: 40px;
        font-size: 14px;
      }
    }

    .deptNews_box_right {
      height: 360px;
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .deptNews_box_right_swiper {
        width: 500px;
        height: 360px;
        overflow: hidden;
        position: relative;

        .banner_carousel {
          overflow: hidden;
        }
      }

      .deptNews_box_right_list {
        width: 640px;
        height: 360px;

        .deptNews_box_right_list_ul {
          width: 100%;
          height: 100%;
          overflow: hidden;

          .deptNews_box_right_list_ul_li {
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .list_ul_li_a1 {
              display: block;
              width: 80%;
              padding-left: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-decoration: none;
              color: #444;
              font-size: 14px;
              position: relative;

              &::after {
                content: "";
                position: absolute;
                width: 5px;
                height: 5px;
                background: #8d080e;
                border-radius: 50%;
                left: 4px;
                top: 48%;
              }

              &:hover {
                color: #AB330E;
              }
            }

            .list_ul_li_a2 {
              width: 20px;
              height: 20px;
              display: inline-block;
              line-height: 20px;

              img {
                width: 100%;
              }
            }

            .list_ul_li_span {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }
  }
}

// 通知公告
.notice {
  background: #f9f9f9;
  height: 465px;

  .notice_ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 430px;

    .notice_con {
      width: 375px;
      height: 350px;
      border: 1px solid #eee;
      background: #fff;

      .notice_con_title {
        padding: 0 20px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          font-size: 24px;
          color: #444;
          line-height: 54px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            background: #8d080e;
            bottom: 2px;
            left: 0;
          }
        }

        a {
          color: #666666;

          &:hover {
            color: #7c2c2c;
          }
        }
      }

      .notice_con_list {
        height: 280px;
        padding: 0 20px;
        overflow: hidden;

        .notice_con_list_ul {
          width: 100%;
          height: 100%;
          padding-top: 10px;

          .notice_con_list_ul_li {
            height: 45px;
            padding-left: 20px;
            position: relative;
            border-bottom: 1px solid #eee;
            line-height: 45px;
            display: flex;
            justify-content: space-around;
            align-items: center;

            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #8d080e;
              border-radius: 50%;
              left: 0;
              top: 50%;
            }

            .notice_con_list_ul_li_a {
              width: 100%;
              color: #333;
              display: block;
              text-decoration: none;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;

              &:hover {
                color: #7c2c2c;
              }
            }
          }
        }
      }
    }
  }
}

// 实习实诊
.shiX {
  height: 453px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .shiX_left {
    width: 375px;
    height: 350px;
    border: 1px solid #eee;
    background: #fff;

    .shiX_left_title {
      padding: 0 20px;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 24px;
        color: #444;
        line-height: 54px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 2px;
          background: #8d080e;
          bottom: 2px;
          left: 0;
        }
      }

      a {
        color: #666666;

        &:hover {
          color: #7c2c2c;
        }
      }
    }

    .shiX_left_list {
      height: 280px;
      padding: 0 20px;
      overflow: hidden;

      .shiX_left_list_ul {
        width: 100%;
        height: 100%;
        padding-top: 10px;

        .shiX_left_list_ul_li {
          display: flex;
          justify-content: space-around;
          align-items: center;
          height: 45px;
          padding-left: 20px;
          position: relative;
          border-bottom: 1px solid #eee;
          line-height: 45px;

          a {
            width: 100%;
            color: #333;
            display: block;
            text-decoration: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 15px;

            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #8d080e;
              border-radius: 50%;
              left: 0;
              top: 50%;
            }

            &:hover {
              color: #7c2c2c;
            }
          }
        }
      }
    }
  }

  .shiX_right {
    width: 785px;
    height: 350px;
    border: 1px solid #eee;
    background: #fff;

    .shiX_right_title {
      width: 90%;
      border-bottom: 1px solid #eee;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 24px;
        color: #444;
        line-height: 48px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          background: #9e070e;
        }
      }

      a {
        text-decoration: none;
        color: #666;
        position: relative;
        line-height: 40px;
        font-size: 14px;
      }
    }

    .shiX_right_list {
      height: 295px;
      padding: 0 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .shiX_right_list_ul {
        width: 100%;
        height: 100%;
        overflow: hidden;

        .shiX_right_list_ul_li {
          height: 60px;
          line-height: 60px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #eee;

          a {
            display: block;
            width: 70%;
            padding-left: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-decoration: none;
            color: #444;
            font-size: 14px;
            position: relative;

            &::after {
              content: '';
              position: absolute;
              width: 5px;
              height: 5px;
              background: #444;
              border-radius: 50%;
              left: 4px;
              top: 48%;
            }

            &:hover {
              color: #7c2c2c;
            }
          }

          span {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
  }

  .shiX_right {

  }
}

div {
  box-sizing: border-box !important;
}

.active {
  span {
    color: #8D0835 !important;
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}

.nav {
  &:hover {
    background-color: #9E070E;
  }
}

.dropdown_menu {
  .dropdown_menu1 {
    div {
      color: #000;

      &:hover {
        color: #fff;
      }
    }
  }
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    text-align: center;
  }

  .content {
    padding-left: 0;
  }
}

</style>
<style lang="less">
.swiper2 {
  width: 500px;
  height: 360px;
  background: #990000;
  overflow: hidden;
  position: relative;

  .swiper_img2 {
    cursor: pointer;
    position: relative;

    .swiper_img2_lefttop {
      position: absolute;
      width: 62px;
      height: 62px;
      background-color: #990000;
      top: 15px;
      left: 15px;

      span {
        &:nth-child(1) {
          display: inline-block;
          color: #fff;
          font-size: 24px;
          font-weight: bold;
          width: 62px;
          text-align: center;
          line-height: 38px;
        }

        &:nth-child(2) {
          display: inline-block;
          width: 62px;
          color: #fff;
          font-size: 14px;
          text-align: center;
        }
      }
    }

    .swiper_img2_title {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 45px;
      background: rgba(0, 0, 0, 0.5);

      span {
        width: 60%;
        font-size: 14px;
        overflow: hidden;
        color: #fff;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 45px;
        margin-left: 30px;
      }
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.swiper-pagination2 {
  position: absolute;
  bottom: 0 !important;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 9999;
  width: 475px !important;
  height: 45px;
  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    border: 1px solid #fff !important;
    opacity: 1 !important;
    background: transparent !important;
    margin: 0 4px;
    box-sizing: content-box !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    margin: 0 4px;
    background: #8d080e !important;
    border: 1px solid #fff !important;
    opacity: 1 !important;
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    box-sizing: content-box !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/connected/cultural/cultural.vue